<template>
  <div>
    <div class="title">
            <p>{{ this.$store.state.titles }}</p>
        </div>
        <div class="main">
            <el-card class="mb10">
                <span> <el-input v-model="server_number" style="width: 240px" placeholder="请输入申请单号" clearable></el-input> </span>
                <span> <el-input v-model="ordernumber" style="width: 240px" placeholder="请输入商品订单编号" clearable></el-input> </span>
                <span>
                    <el-button type="primary" @click="rufsh">搜索</el-button>
                </span>
                <span>
                    <el-button type="primary" @click="init">重置</el-button>
                </span>
                <span>
                    <el-button type="success" @click="bindData" :loading="disbtn">导出</el-button>
                </span>
            </el-card>
            <el-card>
                <div class="table">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane v-for="(item,index) in StatusBar" :key="index" :label="item.name" :name="item.value">
                            <childList ref="listBlo" :orderchildsn="ordernumber" :server_number="server_number" :status="activeName" v-if="activeName==item.value"/>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </el-card>
        </div>
  </div>
</template>
<script>
import childList from "./component/retunTablist.vue"
export default {
  components:{childList},
  data(){
    return{
      ordernumber:"", //搜索框输入
      StatusBar:[ //退款列表的状态
          {name:"全部申请",value:"0"},
          {name:"待处理",value:"1"},
          {name:"待退货",value:"5"},
          {name:"待退款",value:"7"},
          {name:"已处理",value:"2"},
          {name:"已拒绝",value:"3"},
      ],
      activeName:"0", //当前默认列表的Tab栏
      disbtn: false, //导出按钮loading是否展示
      server_number:null,//服务单号查新
    }
  },
  created(){

  },
  methods:{
    init(){
      this.server_number=null,//服务单号查新
      this.activeName='1'
      this.ordernumber=''
      this.$refs.listBlo[0].getRefundList()
    },
    rufsh(){ //搜索框事件
      this.$refs.listBlo[0].getRefundList()
    },
    bindData(){
      this.$refs.listBlo[0].ExportWord();
    },
    handleClick(val){  //Tab栏点击事件
      // this.$refs.listBlo[0].status=val.name
      this.activeName=val.name
      // this.$refs.listBlo[0].getRefundList(val.name)
    },
  }
}
</script>
<style lang="scss" scoped>
.title {
  box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
  width: 100%;
  background: #fff;
  padding: 15px 32px;
  display: flex;
  align-items: center;
  p {
    font-size: 16px;
    color: #333;
    margin-left: 32px;
    span {
      color: #e72f0d;
      padding: 0 5px;
    }
    &:first-child {
      font-size: 18px;
      color: #333;
      margin-left: 0;
    }
    &:nth-child(2) {
      span {
          color: #2448ff;
      }
    }
  }
}
.main {
  margin: 24px;
  min-width: 1200px;
  span {
      margin-right: 10px;
      ::v-deep .el-input {
          width: 150px;
          display: inline-block;
      }
  }
}
</style>
